import {Task} from "@megaphonenpm/mputils/src/Task.js";
import {MegaScreen} from "./MegaScreen.js";
import {get} from 'lodash-es';

/**
 * Applies the loaded deployment settings.
 */
export class ApplyDeploymentSettingsTask extends Task {
  constructor () {
    super();
    this.name = 'APPLY_DEPLOYMENT_SETTINGS';
  }

  start () {
    super.start();
    document.body.style.backgroundColor = get(MegaScreen.globals.dataStore.deploymentSettings, 'screen.background_color');
    this.done();
  }
}